import { max, min } from 'lodash';

import { hygraphClient } from '@/lib/graphql-clients';
import {
  JobBlock,
  JobBlockDisplayType,
  Page,
  PageSidebar,
  RowrowComponentsUnion,
} from '@/lib/types';
import { getSdk } from '@/lib/types';

import PublicJobsService, { Job } from '@/services/public-jobs.service';
import { getPageComponents } from '@/utils/page-static-utils';

const getJobsForBlock = async (jobBlock: JobBlock) => {
  const discipline =
    jobBlock.specialty?.discipline?.apiId || jobBlock.discipline?.apiId;
  const specialty = jobBlock.specialty?.apiName || undefined;

  if (!discipline) {
    return { jobs: [] };
  }

  return PublicJobsService.getAll({
    specialties: specialty,
    discipline: discipline,
    // min 4 | max 10
    limit: min([max([jobBlock.limit || 0, 4]), 10]),
  });
};

const getAll = async (page: Page): Promise<Record<string, Job[]>> => {
  const isJobBlockCarousel = (rc: RowrowComponentsUnion) =>
    rc.__typename === 'JobBlock' &&
    rc.jobBlockDisplayType === JobBlockDisplayType.CardCarousel;

  const jobsComponents = getPageComponents(
    page,
    isJobBlockCarousel
  ) as JobBlock[];

  if (!jobsComponents.length) {
    return {};
  }

  const props = await Promise.all(
    jobsComponents.map(
      async (component: JobBlock): Promise<[string, Job[]]> => {
        const { jobs } = await getJobsForBlock(component);
        return [component.id, jobs];
      }
    )
  );

  return Object.fromEntries(props);
};

const getBySlug = async (slug: string) => {
  const preview = false;
  const sdk = getSdk(hygraphClient(preview));
  const { pageSidebars } = await sdk.Sidebars({
    where: { slug },
  });

  return pageSidebars.at(-1) as unknown as PageSidebar;
};

const JobBlocksService = {
  getAll,
  getBySlug,
};

export default JobBlocksService;
